// @flow

import { createActions, handleActions } from 'redux-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import RestClient from 'frontend_core/dist/rest/client'

/**
 ************************************************************
 * 初期ステート
 ************************************************************
 **/

const initialState = {
  largeAreas: [],
  isFetchingLargeAreas: false,

  industries: [],
  isFetchingIndustries: false,

  jobs: [],
  isFetchingJobs: false,
}

/**
 ************************************************************
 * ActionTypes
 ************************************************************
 **/

const actionTypes = {
  FETCH_LARGE_AREAS: 'FETCH_LARGE_AREAS',
  SET_LARGE_AREAS: 'SET_LARGE_AREAS',

  FETCH_INDUSTRIES: 'FETCH_INDUSTRIES',
  SET_INDUSTRIES: 'SET_INDUSTRIES',

  FETCH_JOBS: 'FETCH_JOBS',
  SET_JOBS: 'SET_JOBS',
}

/**
 ************************************************************
 * Actions
 ************************************************************
 **/

export const actions = createActions(
  actionTypes.FETCH_LARGE_AREAS,
  actionTypes.FETCH_INDUSTRIES,
  actionTypes.FETCH_JOBS,
)

/**
 ************************************************************
 * reducer
 ************************************************************
 **/

export const reducer = handleActions(
  {
    [actionTypes.FETCH_LARGE_AREAS]: state => ({
      ...state,
      isFetchingLargeAreas: true,
    }),
    [actionTypes.SET_LARGE_AREAS]: (state, action) => ({
      ...state,
      largeAreas: action.payload,
      isFetchingLargeAreas: false,
    }),

    [actionTypes.FETCH_INDUSTRIES]: state => ({
      ...state,
      isFetchingIndustries: true,
    }),
    [actionTypes.SET_INDUSTRIES]: (state, action) => ({
      ...state,
      industries: action.payload,
      isFetchingIndustries: false,
    }),

    [actionTypes.FETCH_JOBS]: state => ({
      ...state,
      isFetchingJobs: true,
    }),
    [actionTypes.SET_JOBS]: (state, action) => ({
      ...state,
      jobs: action.payload,
      isFetchingJobs: false,
    }),
  },
  initialState,
)

/**
 ************************************************************
 * API連携 非同期アクション
 ************************************************************
 **/

// 都道府県を取得
function* fetchLargeAreas({ payload }) {
  try {
    const results = yield call(
      RestClient.get,
      `1/countries/${(payload || {}).countryId || 1}/large_areas`,
    )
    yield put({ type: actionTypes.SET_LARGE_AREAS, payload: results })
  } catch (e) {
    yield put({ type: actionTypes.SET_LARGE_AREAS, payload: [] })
  }
}

// 業種を取得
function* fetchIndustries() {
  try {
    const results = yield call(RestClient.get, '1/industries')
    yield put({ type: actionTypes.SET_INDUSTRIES, payload: results })
  } catch (e) {
    yield put({ type: actionTypes.SET_INDUSTRIES, payload: [] })
  }
}

// 職種を取得
function* fetchJobs() {
  try {
    const results = yield call(RestClient.get, '1/jobs')
    yield put({ type: actionTypes.SET_JOBS, payload: results })
  } catch (e) {
    yield put({ type: actionTypes.SET_JOBS, payload: [] })
  }
}

/**
 ************************************************************
 * saga
 ************************************************************
 **/

export const masterSagas = [
  takeEvery(actionTypes.FETCH_LARGE_AREAS, fetchLargeAreas),
  takeEvery(actionTypes.FETCH_INDUSTRIES, fetchIndustries),
  takeEvery(actionTypes.FETCH_JOBS, fetchJobs),
]



// WEBPACK FOOTER //
// ./src/redux/modules/remote/master.js